const committees = [
    { value: '0', name: 'None', cluster_id: null },
    { value: '1', name: 'Executive Committee', cluster_id: 4 },
    { value: '2', name: 'Committee of Committees', cluster_id: 4 },
    { value: '3', name: 'Committee of Chairpersons', cluster_id: 4 },
    { value: '4', name: 'Rules Committee', cluster_id: 4 },
    { value: '5', name: 'Programming Committee', cluster_id: 4 },
    { value: '6', name: 'Sub-Committee on the Review of Rules', cluster_id: 4 },
    { value: '7', name: 'Sub-Committee on Policy Development', cluster_id: 4 },
    { value: '8', name: 'Sub-Committee of Internal Arrangements', cluster_id: 4 },
    { value: '9', name: 'Sub-Committee on Human Resource Development', cluster_id: 4 },
    { value: '10', name: 'Multi-party Whips Committee', cluster_id: 4 },
    { value: '11', name: 'Legislature Oversight Committee', cluster_id: 4 },
    { value: '12', name: 'Standing Committee on Public Accounts', cluster_id: 4 },
    { value: '13', name: 'Standing Committee on Law Review', cluster_id: 4 },
    { value: '14', name: 'Standing Committee on Women\'s Caucus', cluster_id: 4 },
    { value: '15', name: 'Standing Committee on Public Participation, Petitions and Education', cluster_id: 4 },
    { value: '16', name: 'Standing Committee on Special Programmes', cluster_id: 4 },
    { value: '17', name: 'Standing Committee on Budget and Money Bills', cluster_id: 4 },
    { value: '18', name: 'Portfolio Committee on Education', cluster_id: 1 },
    { value: '19', name: 'Portfolio Committee on Health', cluster_id: 1 },
    { value: '20', name: 'Portfolio Committee on Sport, Recreation, Arts and Culture', cluster_id: 1 },
    { value: '21', name: 'Portfolio Committee on Public Works', cluster_id: 2 },
    { value: '22', name: 'Portfolio Committee on Human Settlements', cluster_id: 1 },
    { value: '23', name: 'Portfolio Committee on Roads and Transport', cluster_id: 2 },
    { value: '24', name: 'Portfolio Committee on Finance and Provincial Expenditure', cluster_id: 3 },
    { value: '25', name: 'Portfolio Committee on Office of the Premier', cluster_id: 3 },
    { value: '26', name: 'Portfolio Committee on Co-operative Governance and Traditional Affairs', cluster_id: 3 },
    { value: '27', name: 'Portfolio Committee on Social Development', cluster_id: 1 },
    { value: '28', name: 'Portfolio Committee on Economic Development, Environmental Affairs and Tourism', cluster_id: 2 },
    { value: '29', name: 'Portfolio Committee on Rural Development and Agrarian Reform', cluster_id: 2 },
    { value: '30', name: 'Portfolio Committee on Safety and Liaison', cluster_id: 1 },
    { value: '31', name: 'Ethics Committee', cluster_id: 4 }
];
export default committees;